/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "7QEW_F_dGTk",
    title: "Naruto Vs Pain",
    description:
      "Naruto protects the hidden leaf village from the six paths pain in an epic clash. Naruto unleashes nine-tails power.",
    catchName: "Hero of the village",
    category: "fights",
    uploaded: "May 24, 2021",
  },
  {
    _id: "Q9m_QQ_CLHA",
    title: "Naruto vs Obito( Sage of Six Paths )",
    description:
      "Naruto Cries & Teams up with Sasuke To Fight Obito Sage of Six Paths ENG DUB.",
    catchName: "For Comrades",
    category: "fights",
    uploaded: "Jul 27, 2021",
  },
  {
    _id: "3nYA93ofdhE",
    title: "Naruto-Sasuke Vs Madara",
    description:
      "After receiving powers from Hagaromo Sasuke and Naruto joins to fight Madara. Naruto has awaken six path sage jutsu and Sasuke has awaken one eyed Rinnegan.",
    catchName: "The Divine Tree.",
    category: "fights",
    uploaded: "Aug 11, 2019",
  },
  {
    _id: "b4yUG_5PwCo",
    title: "Naruto Vs Sasuke Final Battle",
    description:
      "Naruto and Sauke fights the final battle to settle things for good.",
    catchName: "For the future.",
    category: "fights",
    uploaded: "Aug 31, 2021",
  },
  {
    _id: "0GR5JlkHG-I",
    title: "Naruto Vs Neji",
    description:
      "Naruto fights Neji in the first ever Chunin Exams of the Anime.",
    catchName: "Our Own Destiny.",
    category: "fights",
    uploaded: "Aug 3, 2013",
  },
  {
    _id: "m9woA4hPNII",
    title: "Naruto Shippuden Funny Moments",
    description: "Naruto Shippuden funnmy moments involving team 7.",
    catchName: "Fun Times",
    category: "comedy",
    uploaded: "May 24, 2021",
  },
  {
    _id: "WD9BKgWgV1s",
    title: "Naruto Being Naruto",
    description: "Naruto funny moments and naruto being dumb.",
    catchName: "Funny Naruto",
    category: "comedy",
    uploaded: "Jan 31, 2021",
  },
  {
    _id: "0bjicmknkVw",
    title: "The Tale of 7th Hokage Naruto Uzumaki",
    description:
      "The boy who grew up with nothing, never gave up and obtained everything. The tale of the greatest ninja Naruto Uzumaki.",
    catchName: "Hokage",
    category: "amv",
    uploaded: "Jan 29, 2021",
  },
  {
    _id: "fjEcAgS4jcE",
    title: "Silence ft. Saddest AMV",
    description:
      "This AMV depicts the pain and loss of our favorite characters.",
    catchName: "One Last Time",
    category: "amv",
    uploaded: "Jan 22, 2021",
  },
  {
    _id: "ND0UeXeHB4A",
    title: "Naruto [AMV] • lovely (all alone)",
    description:
      "Naruto was alone in his life from beginning, amv is dedicated to loneliness.",
    catchName: "All Alone",
    category: "amv",
    uploaded: "Jul 13, 2018",
  },
  {
    _id: "sE2pYubPT8k",
    title: "Naruto & Sasuke vs Momoshiki (AMV) - Fearless",
    description:
      "Naruto and Sasuke indeed were fearless which this song depicts in the same way.",
    catchName: "Courageous Boys",
    category: "amv",
    uploaded: "Sep 4, 2020",
  },
  {
    _id: "BXOMzNyQp08",
    title: "Naruto Shippuden Tiktok Compilation",
    description:
      "Tiktok compilation from naruto shippuden.",
    catchName: "Ninjas in Music",
    category: "tiktok",
    uploaded: "Jan 10, 2022",
  },
  {
    _id: "U6hlKJAIHYY",
    title: "Naruto tiktok compilation",
    description:
      "Naruto protects the hidden leaf village from the six paths pain in an epic clash. Naruto unleashes nine-tails power.",
    catchName: "Hero of the village",
    category: "tiktok",
    uploaded: "Nov 17, 2021",
  },
];
